import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {ImageService} from '../../../core/services/image/image.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ImageCroppedEvent} from 'ngx-image-cropper';

@Component({
  selector: 'app-upload-icon',
  templateUrl: './upload-icon.component.html',
  styleUrls: ['./upload-icon.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UploadIconComponent),
      multi: true,
    },
  ],
})
export class UploadIconComponent implements ControlValueAccessor, OnChanges {
  @Input() selectedImage = '';
  @Input() titleLabel = 'Icon';
  @Input() hideRemove = false;
  @Input() readonly = false;
  @Input() imagePreviewHeight = 140;
  @Input() imagePreviewWidth = 140;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() remove: EventEmitter<any> = new EventEmitter();
  @ViewChild('careplanImg', {read: ElementRef}) public careplanImg: ElementRef;

  public defaultImgUrl = './assets/main/temp/image-icon.svg';

  public uploadImageLabel = 'Upload Image';
  public saveLabel = 'Save';
  public removeLabel = 'Remove';

  public imageChangedEvent: any = '';

  public cropperReady = false;

  constructor(private imageService: ImageService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.selectedImage && changes.selectedImage.currentValue) {
      this.propagateChange(this.selectedImage);
    }
  }

  public onFileChanged(event) {
    const {
      target: {files},
    } = event;

    if (files && files[0]) {
      this.imageChangedEvent = event;
    }
  }

  public imageCroppedBase64(event: ImageCroppedEvent) {
    this.selectedImage = event.base64;
  }

  public loadImageFailed() {
    console.log('Load failed');
  }

  public removeImg() {
    this.selectedImage = '';
    this.cropperReady = false;
    this.careplanImg.nativeElement.value = '';
    this.propagateChange('');
    this.remove.emit();
  }

  public saveImg() {
    this.cropperReady = false;
    if (this.selectedImage) {
      this.change.emit(this.selectedImage);
      this.propagateChange(this.selectedImage);
    } else {
      this.imageService.convertAssetToImage('./assets/main/careplan/careplan-no-image.png', (base64Image) => {
        this.selectedImage = base64Image;
        this.propagateChange(this.selectedImage);
        this.change.emit(base64Image);
      });
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    if (val) {
      this.selectedImage = val;
      // console.log(val);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  private propagateChange = (_: any) => {};

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.readonly = !!isDisabled;
  }
}
